import * as React from 'react'
import HomeCardViewItem from './HomeCardViewItem'
import HomeType from '../../types/HomeType'
import * as Styles from './HomeCardView.style'

interface HomeCardViewProp {
    moduleid: number,
    data: {
        name: string,
        contents: HomeType.Content[]
    }
}

function HomeCardView(props: HomeCardViewProp) {
    return (
        <div>
            <div className={Styles.titleName}>{props.data.name}</div>
            <div className={Styles.HomeCardViewItemWrap}>
                {props.data.contents.map((item: HomeType.Content, index) => {
                        return (
                            <HomeCardViewItem content={item} key={index} moduleName={props.data.name} moduleid={props.moduleid} index={index}/>
                        )
                    })
                }
            </div>
        </div>
    )
}

export default HomeCardView



// WEBPACK FOOTER //
// ./src/views/Home/components/HomeCardView/HomeCardView.tsx